import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormValidationService, LookupService } from '../../shared';
import { Subscription } from 'rxjs/Subscription';
import { MODE } from '../../shared/constant';

// DropdownboxComponent
@Component({
  selector: 'dropdown-component',
  styleUrls: ['./../question.scss'],
  template: `
    <div [class.has-error]="(isSubmitClicked && !control?.valid) || (control?.errors?.Required && mode != 'readOnly')"
         [ngClass]="{'col-md-4 inline-padding': questiondata.params.inline == 3}"
         [ngClass]="{'col-md-3 inline-padding': questiondata.params.inline == 4}"
         [attr.id]="sectionId+'_'+questiondata.order+'_div'">
      <label-text [questiondata]="questiondata" [helptext]="questiondata.helpText"
                  [attrFor]="sectionId+'_'+questiondata.order+'_'+order+'_dropdown'"></label-text>
      <div>
        <select class="form-control" role="menu" [(ngModel)]="response" [formControl]="control"
                [attr.id]="sectionId+'_'+questiondata.order+'_'+order+'_dropdown'" (change)="onChange($event)"
                [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' ">
          <option value="" [attr.selected]>Select</option>
          <option *ngFor="let option of options; let i=index" [value]="option.value">{{option.display}}</option>
        </select>
        <errorMessages *ngIf="mode != 'readOnly'" [control]='control' [params]='questiondata.params'
                       [isSubmitClicked]="isSubmitClicked"></errorMessages>
        <span *ngIf="errorMessage.status==0 && mode != 'readOnly'" class="text-danger">An error occured</span>
      </div>
      <br/>

    </div> <br *ngIf="!questiondata.params.inline"/>
  `,
})

export class DropdownComponent implements OnInit {
  @Input() questiondata: any;
  @Input() controlObject: any;
  @Input() control: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked;
  @Input() mode;
  @Input() campusCode: string;


  @Output() onSelectedOther: EventEmitter<any> = new EventEmitter();

  response = '';
  errorMessage: any = {};
  options = [];
  // TODO: this prop is being referenced on lines 12 and 14, but wasn't declared; adding it here so that the compilation doesn't fail
  order: any;
  private lookup = {};
  private selectedDropdownValue = '';

  constructor(private _lookupService: LookupService, private _formValidationService: FormValidationService) {
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changes: any) {
    if (changes.mode) {
      this.init();
    }
  }

  init() {
    if (this.mode === MODE.READONLY) {
      this.options = this.questiondata.iterations[0].responseMetadata && this.questiondata.iterations[0].responseMetadata['allowedResponses'];
      this.response = this.response || this.questiondata.iterations[0].responseText;
      this.control.setValue(this.response);
      this.control.disable(true);
    } else {
      this.lookupApi();
      this.control.enable(true);
    }
  }

  lookupApi() {
    let lookupApi = this.questiondata.params.lookupApi;

    if (lookupApi) {
      if (this.questiondata.params.lookupApiDependencyCode) {
        let parentControl = this._formValidationService.getQuestionControl(this.questiondata.params.lookupApiDependencyCode);
        if (parentControl) {
          parentControl.valueChanges.subscribe(response => {
              if (response) {
                this._lookupService.getLookupBasedOnSearch(lookupApi, response, this.campusCode).then(data => {
                  if (data) {
                    this.options = data;
                    this.control.setValue(this.questiondata.iterations[0].responseText);
                  } else {
                    this.options = [];
                  }
                });
              } else {
                this.options = [];
                this.selectedDropdownValue = '';
              }
            },
            error => this.errorMessage = <any>error);
        }
      } else {
        this._lookupService.getLookup(lookupApi, this.campusCode).then(data => {
            this.options = data['options'] || [];
            this.control.setValue(this.questiondata.iterations[0].responseText);
          }).catch(error => this.errorMessage = <any>error);
      }
    } else {
      this.options = this.questiondata.allowedOptions;
      this.response = this.response || this.questiondata.iterations[0].responseText;
      this.control.setValue(this.response);
    }
  }

  onChange(event) {
    let value = event.target.value;
    this.selectedDropdownValue = value;
    this.controlObject.value.iterations[0].responseMetadata['allowedResponses'] = this.options;
    if (value) {
      this.options.forEach(option => {
        if (option.value === value) {
          this.onSelectedOther.emit(false);
          this.controlObject.value.iterations[0].responseMetadata['chosenResponses'][0] = option;
          if(value === 'OTHER') {
            this.onSelectedOther.emit(true);
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/controls/dropdown.component.ts